/** Settings wizard step definitions (1-indexed for URL ?step=). */
export const SETTINGS_STEPS = [
  {
    id: 1,
    key: 'category',
    label: 'Category Type',
    title: 'Category Type',
    description: 'Define the type and basic details for this category type.',
  },
  
  {
    id: 2,
    key: 'workflow',
    label: 'Workflow',
    title: 'Workflow',
    description: 'L1 > L2 > L3',
  },
  {
    id: 3,
    key: 'formFields',
    label: 'Form Fields',
    title: 'Form Fields',
    description: '----',
  },
  {
    id: 4,
    key: 'review',
    label: 'Review & Publish',
    title: 'Review & Publish',
    description: 'Review your configuration and publish.',
  },
];

export const WORKFLOW_SUBSTEPS = [
  { id: 1, label: 'Create Workflow' },
  { id: 2, label: 'Statuses' },
  { id: 3, label: 'Workflow Steps' },
];

export const QUICK_PRIORITIES = ['Urgent', 'High', 'Medium', 'Low'];

export const FIELD_LIBRARY = [
  { id: 'short', label: 'Textfield / Short Answer', icon: 'text' },
  { id: 'long', label: 'Description / Long Answer', icon: 'doc' },
  { id: 'date', label: 'Date', icon: 'calendar' },
  { id: 'time', label: 'Time', icon: 'clock' },
  { id: 'single', label: 'Dropdown - Single Select', icon: 'chevron' },
  { id: 'multi', label: 'Dropdown - Multiple Select', icon: 'chevron' },
];

export const DEMO_ROLES = [
  'Store Staff',
  'HR Executive',
  'HR Manager',
  'Store Manager',
  'Admin',
];

export const DEMO_CATEGORY_TYPES = [
  { value: 'qms', label: 'QMS - Query Management System' },
  { value: 'cms', label: 'CMS - Complaint Management System' },
  { value: 'fms', label: 'FMS - Feedback Management System' },
  { value: 'rms', label: 'RMS - Request Management System' },
];

export const DEMO_DEPARTMENTS_TREE = [
  {
    id: 'hr',
    name: 'HR',
    children: [
      { id: 'payroll', name: 'Payroll' },
      { id: 'recruitment', name: 'Recruitment' },
    ],
  },
  {
    id: 'finance',
    name: 'Finance',
    children: [{ id: 'ap', name: 'Accounts Payable' }],
  },
  {
    id: 'it',
    name: 'IT',
    children: [],
  },
];

export const PRIORITY_COLORS = [
  { value: '#EF4444', label: 'Red' },
  { value: '#F59E0B', label: 'Orange' },
  { value: '#EAB308', label: 'Yellow' },
  { value: '#22C55E', label: 'Green' },
  { value: '#3B82F6', label: 'Blue' },
  { value: '#8B5CF6', label: 'Purple' },
];
